import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import CartItem from '../components/cart/CartItem';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../utils/formatting';

export default function CartPage() {
  // Add itemCount to the destructured values from useCart
  const { cartItems, cartTotal, itemCount } = useCart();
  const brandColor = '#e46809';

  // The view for when the cart is empty
  if (cartItems.length === 0) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <ShoppingBagIcon className="w-24 h-24 mx-auto text-gray-300 dark:text-gray-600" />
        <h1 className="mt-4 text-3xl font-bold text-gray-800 dark:text-white">Your Gift Bag is Empty</h1>
        <p className="mt-2 text-gray-500 dark:text-gray-400">Find a campaign to support and make a difference today.</p>
        <Link
          to="/campaigns"
          className="mt-6 inline-block py-3 px-8 text-white font-semibold rounded-lg transition-colors"
          style={{ backgroundColor: brandColor }}
        >
          Browse Campaigns
        </Link>
      </div>
    );
  }

  // The main view for when the cart has items
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-8">
        Your Gift Bag ({itemCount}) {/* Use itemCount instead of cartCount */}
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
        {/* Cart Items List */}
        <div className="lg:col-span-2 bg-white dark:bg-gray-800/50 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            {cartItems.map(item => (
              <CartItem key={item.id} item={item} />
            ))}
          </div>
        </div>

        {/* Order Summary */}
        <div className="lg:col-span-1">
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6 sticky top-28 border border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white border-b border-gray-200 dark:border-gray-600 pb-4 mb-4">
              Summary
            </h2>
            <div className="space-y-2 text-gray-600 dark:text-gray-300">
              <div className="flex justify-between">
                <span>Subtotal</span>
                <span>{formatCurrency(cartTotal)}</span>
              </div>
              <div className="flex justify-between font-bold text-lg text-gray-900 dark:text-white pt-4 border-t border-gray-300 dark:border-gray-600 mt-4">
                <span>Total</span>
                <span>{formatCurrency(cartTotal)}</span>
              </div>
            </div>
            
            <Link 
              to="/campaigns"
              className="mt-8 w-full block text-center py-3 px-4 font-semibold rounded-lg border-2 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              Continue Gifting
            </Link>

            <Link
              to="/checkout"
              className="mt-4 w-full block text-center py-3 text-white font-semibold rounded-lg shadow-lg transition-transform transform hover:scale-105"
              style={{ backgroundColor: brandColor }}
            >
              Proceed to Checkout
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}